import { render, staticRenderFns } from "./EnglishResumeProfileCard.vue?vue&type=template&id=37569a23&scoped=true"
import script from "./EnglishResumeProfileCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnglishResumeProfileCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./EnglishResumeProfileCard.vue?vue&type=style&index=0&id=37569a23&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37569a23",
  null
  
)

export default component.exports